export const HOME_PATH = '/';
export const LOGOUT_PATH = '/logout';

export const ADD_HIRE_PATH = (companyId = ':companyId') =>
  `/companies/${companyId}/add-hire`;

/** Employees */
export const EMPLOYEES_PATH = '/employees';
export const EMPLOYEE_DETAILS_PATH = (employeeId = ':employeeId') =>
  `/employees/${employeeId}`;
export const EMPLOYEE_DOCUMENTS_PATH = (employeeId = ':employeeId') =>
  `/employees/${employeeId}/documents`;
export const EMPLOYEE_ADD_DOCUMENT_PATH = (employeeId = ':employeeId') =>
  `${EMPLOYEE_DOCUMENTS_PATH(employeeId)}/add-document`;
export const EMPLOYEE_CONTRACT_PATH = (
  employeeId = ':employeeId',
  contractId = ':contractId',
) => `/employees/${employeeId}/contracts/${contractId}`;
export const EMPLOYEE_EMPLOYMENTS_PATH = (employeeId = ':employeeId') =>
  `${EMPLOYEE_DETAILS_PATH(employeeId)}/employments`;

/** Seats */
export const getSeatPath = (companyId: string, seatId: string) =>
  `/companies/${companyId}/pending-employee/${seatId}`;

/** Contractors */
export const CONTRACTORS_PATH = '/contractors';
export const CONTRACTOR_DETAILS_PATH = (contractorId = ':contractorId') =>
  `/contractors/${contractorId}`;
export const ADD_CONTRACTOR_PATH = (companyId = ':companyId') =>
  `/companies/${companyId}/add-contractor`;

/** Contractor Invoices */
export const CONTRACTOR_INVOICES_PATH = '/contractor-invoices';
export const CONTRACTOR_INVOICES_DETAILS_PATH = (invoiceId = ':invoiceId') =>
  `/contractor-invoices/${invoiceId}`;
export const CONTRACTOR_INVOICES_PAYMENT_PATH = '/contractor-invoices/pay';

/** Timesheets */
export const TIMESHEETS_PATH = '/timesheets';

/** Invoice Reports */
export const INVOICES_PATH = '/invoices';
export const INVOICE_DETAILS_PATH = (invoiceId = ':invoiceId') =>
  `/invoices/${invoiceId}`;
export const INVOICE_EMPLOYEE_DETAILS_PATH = (
  invoiceId = ':invoiceId',
  employeeId = ':employeeId',
) => `/invoices/${invoiceId}/employees/${employeeId}`;

/** Client details */
export const CLIENT_PROFILE_PATH = '/profile';
export const LEAVE_SETTING_PATH = '/leave-settings';
export const CLIENT_LEAVE_SETTING_WITH_PARAMS_PATH = (
  countryCode = ':countryCode',
  type = ':type',
) => `${LEAVE_SETTING_PATH}?countryCode=${countryCode}&type=${type}`;

/** Time offs */
export const TIME_PATH = '/time';

/** Compensation */
export const COMPENSATION_PATH = '/compensation';
export const ADD_COMPENSATION_PATH = `${COMPENSATION_PATH}/add`;
export const CONTRACTUAL_COMPENSATION_PATH = (employeeId = ':employeeId') =>
  `/employees/${employeeId}/contractual-compensation`;

/** Salary changes */
export const SALARY_CHANGES_PATH = '/salary-changes';
export const ADD_SALARY_CHANGE_PATH = `${SALARY_CHANGES_PATH}/add`;
export const ADD_BULK_SALARY_CHANGES_PATH = `${SALARY_CHANGES_PATH}/add-bulk`;

/** Additional pay */
export const ADDITIONAL_PAY_PATH = '/additional-pay';
export const ADD_ADDITIONAL_PAY_PATH = `${ADDITIONAL_PAY_PATH}/add`;
export const ADDITIONAL_PAY_DETAILS_PATH = (
  variantPaymentId = ':variantPaymentId',
) => `${ADDITIONAL_PAY_PATH}/${variantPaymentId}`;

/** Add document */
export const DOCUMENTS_PATH = '/documents';
export const ADD_DOCUMENT_PATH = `${DOCUMENTS_PATH}$/add-document`;

/** Error state */
export const ERROR_STATE_TITLE = "Uh-oh, something's gone wrong";
export const ERROR_STATE_DESC =
  'Try reloading the page below, and if this fails get in touch with our support team.';

export const DEFAULT_ERROR_TITLE = 'Error';
export const DEFAULT_ERROR_DESCRIPTION =
  'Something went wrong. Please contact support.';

/** Integrations */
export const INTEGRATIONS_PATH = '/integrations';
export const XERO_CONFIGURATION_PATH = `${INTEGRATIONS_PATH}/xero-configuration`;
export const XERO_ERROR_PATH = `${INTEGRATIONS_PATH}/xero-error`;

/** Benefits */
export const BENEFITS_PATH = '/benefits';

/** Expenses */
export const EXPENSES_PATH = '/expenses';
export const EXPENSES_DETAILS_PATH = (expenseId = ':expenseId') =>
  `/expenses/${expenseId}`;
